export default __webpack_public_path__ + "images/fcfd8fceba3121bb228e22d21971821c-first_aid.webp";